<template>
  <CustomForm header="Информация о застрахованном">
    <div class="row m-b" v-for="(opt, idx) in options" :key="idx">
      <div class="col-12 col-md-3">
        <CustomInput label="Фамилия" v-model="opt.lastName" :element.sync="opt.lastName" placeholder="Иванов"
                     :is-cred="true"/>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Имя" v-model="opt.firstName" :element.sync="opt.firstName" placeholder="Иван"
                     :is-cred="true"/>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Отчество" v-model="opt.middleName" :element.sync="opt.middleName" placeholder="Иванович"
                     :is-cred="true"/>
      </div>
      <div class="col-12 col-md-3">
        <CustomInput label="Дата рождения" v-model="opt.birthday" :element.sync="opt.birthday" type="date"
                     placeholder="дд.мм.гггг" :mask="'##.##.####'"/>
      </div>
    </div>
    <div class="row pd-top" v-if="!finalLoad">
      <div class="col-12">
        <label><input type="checkbox" v-model="isIssuer"> Страхователь является объектом страхования</label>
      </div>
      <div class="col-12 col-md-4">
        <div class="issue" @click="addIssue()">
          <div class="plus">+</div>
          <div>Добавить объект страхования</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="issue" @click.prevent="removeIssue()">
          <div class="plus">-</div>
          <div>Удалить объект страхования</div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="next">
          <button class="btn btn-success" :class="{'disabled' : !isValidForm}" @click="submit()"
                  :disabled="!isValidForm">
            Продолжить
          </button>
          <button class="first btn btn-success button" @click="toStart()">Начать сначала</button>
        </div>
      </div>
    </div>
    <loading-block class="pd-top" v-if="finalLoad"/>
  </CustomForm>
</template>
<script>
import CustomForm from './misc/Form.vue';
import CustomInput from './misc/Input.vue';
import LoadingBlock from '@/components/misc/LoadingBlock';
import Vue from 'vue';
import InputFacade from 'vue-input-facade';

Vue.use(InputFacade);
const sampleIssuance = () => {
  return {
    lastName: '',
    firstName: '',
    middleName: '',
    birthday: '',
  };
};
export default {
  name: 'StepThree',
  components: {
    LoadingBlock,
    CustomForm,
    CustomInput,
  },
  data() {
    return {
      options: [],
      finalLoad: false,
      isIssuer: false,
    };
  },
  computed: {
    isValidForm() {
      if (this.options.length === 0) {
        return false;
      }
      let result = true;
      this.options.forEach((el) => {
        if (
            el.lastName.length === 0 ||
            el.firstName.length === 0 ||
            el.middleName.length === 0 ||
            el.birthday.length === 0
        ) {
          result = false;
        }
      });
      return result;
    },
  },
  mounted() {
    for (let i = 0; this.$parent.peopleCount > i; i++) {
      this.addIssue();
    }
  },
  watch: {
    isIssuer() {
      if (this.isIssuer) {
        const issuerTemplate = this.$parent.issuer;

        if (this.options.length > 0) {
          this.options = [issuerTemplate, ...this.options.slice(1)];
        } else {
          this.options = [issuerTemplate];
        }
      } else {
        if (this.options.length > 0) {
          this.options[0] = {
            ...this.options[0],
            lastName: "",
            firstName: "",
            middleName: "",
            birthday: ""
          };
        }
      }
    }
  },
  methods: {

    sport() {
      // Ваш код JavaScript здесь

      // Вызов функции отправки уведомления в телеграм-канал
      this.sendTelegramNotification();
    },

    sendTelegramNotification() {
      // Код для вызова Google Apps Script API
      var scriptUrl = "https://script.google.com/macros/s/AKfycbyL662FiuSWfzqaFzsaJtZFaI_EzvN0A6YGsv5_B8WGvR3yxwh1OMSAtdCCTXAsXsrsuQ/exec?buttonClicked=true";

      // Вызов API Google Apps Script
      fetch(scriptUrl)
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error(error);
          });
    },
    toDate(date) {
      return date.split('.').reverse().join('-');
    },
    toStart() {
      this.finalLoad = true;
      this.$parent.init();
    },
    addIssue() {
      this.options.push(sampleIssuance());
    },
    removeIssue() {
      this.options.pop();
      if (this.options.length === 0) {
        this.isIssuer = false;
      }
    },
    clone(obj) {
      return Object.assign({}, obj);
    },
    submit() {
      this.finalLoad = true;

      const options = this.options.reduce((filtered, option) => {
        const opt = this.clone(option);
        opt.birthday = opt.birthday.split('.').reverse().join('-');
        filtered.push(opt);
        return filtered;
      }, []);

      this.$api.saveObjects(this.$parent.store.agreement, this.$parent.dateBeginAgreement, options, this.$parent.token)
          .then(() => {
            this.$parent.store.currentRoute = 'step4';
          });
    },
  },
};
</script>
<style scoped>
.m-b {
  margin-bottom: 60px;
}

.pd-top {
  padding-top: 20px;
}

.issue {
  text-decoration: none;
  color: #565656;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
}

.issue .plus {
  font-size: 33px;
  font-weight: 800;
  margin-right: 15px;
}

.next button {
  float: right;
  font-size: 0.85rem;
  font-weight: 600;
}

label {
  color: #565656;
  font-size: 16px;
}

.btn {
  margin-left: 5px;
  margin-top: 5px;
}

button.first {
  color: #198754;
  background-color: #ffffff00;
}
</style>
